module.exports = __webpack_public_path__ + "img/digital_jiazhi.603b78f6.png";